import React from "react"
import { Link } from "gatsby"
import { getUser } from "../services/auth"
const Profile = () => {
  const { name, email } = getUser()
  return (
    <>
      <h1>Your profile</h1>
      <ul>
        <li>Name: {name}</li>
        <li>E-mail: {email}</li>
      </ul>
      <p>
        <Link to="/app/logout">Log out</Link>
      </p>
    </>
  )
}
export default Profile
